function hall2019girlSet(conf){
    conf=$.extend(true,{
        girlObj:[],
        lineX:[0,280,560]
    },conf);
    myPixiElement.container.call(this,{});
    this.conf=conf;
    this.girl_ids=[];
    this.animArr=[];
    this.fadeArr=[];
    this.girlSet={};
    var i,girl_id,bum;
    for(i in conf.girlObj){
        bum=conf.girlObj[i];
        girl_id=bum.girl_id;
        this.girlSet[girl_id]=new myPixiObj.myGirl({
            girl_id:girl_id,
            suitObj:copyObj(bum.suitObj)
        });
        this.girl_ids.push(girl_id);
        this.girlSet[girl_id].alpha=0;
    }
    this.girlCointainer=new PIXI.Container();
    this.animCointainer=new PIXI.Container();
    this.girlCointainer.scale.set(0.4);
    
    this.girlCointainer.x=1070;
    this.girlCointainer.y=460;
    
    this.storage={
        activeArr:[],
        girl_ids:[],
        was_started:false,
    };
    this.resources;//assign in init
    this.bad;
    this.good;
    this.puffArr={};
    this.timeIndex={
        "good":_moduleTimeHandler.getNewIndex(),
        "bad":_moduleTimeHandler.getNewIndex(),
    };
    
}
hall2019girlSet.prototype = Object.create(myPixiElement.container.prototype);
hall2019girlSet.prototype= $.extend(hall2019girlSet.prototype,{
    init:function(resources){
        this.resources=resources;
        var girl_id;
        for(girl_id in this.girlSet){
            this.girlSet[girl_id].init();
            this.girlCointainer.addChild(this.girlSet[girl_id]);
        }
        this.addChild(this.animCointainer);
        this.addChild(this.girlCointainer);
        
        
        this.bad=new myPixiElement.spine({
            img:"witch_bad",
            spine_conf:{
                spineResource:resources,
                onAnimComplete:function(){
                    if(mt_rand(1,100)>50){
                        this.playAnim("animation");
                    }
                    else{
                        this.playAnim("animation2");
                    }
                    
                }
            },
            
            
        });
        this.bad.alpha=0;
        this.good=new myPixiElement.spine({
            img:"witch_good",
            spine_conf:{
                spineResource:resources,
                onAnimComplete:function(){
                    this.playAnim("animation")
                }
            },
            
            
        });
        this.puffArr.pink_in=new myPixiElement.spine({
            img:"puff_pink",
            spine_conf:{
                spineResource:resources,
                auto_start:false
            }
            
        });
        this.puffArr.pink_in.x=1070;
        this.puffArr.pink_in.y=360;
        
        
        this.addChild(this.puffArr.pink_in);
        
        this.addChild(this.good);
        this.addChild(this.bad);
        this.prepareFirstLine();
        
        
        this.addChild(new myPixiElement.img({img:"workaround",anchor:[0,0]}));
        
        this.fadeIn(20);
    },
    prepareFirstLine:function(){
        this.alpha=0;
        var cur_ids=getRandomArrayElements(this.girl_ids,this.conf.lineX.length);
        var i,x,girl_id;
        for(i in this.conf.lineX){
            x=this.conf.lineX[i];
            girl_id=cur_ids[i];
            this.girlSet[girl_id].x=x;
            this.girlSet[girl_id].alpha=1;
            this.storage.activeArr.push(this.girlSet[girl_id]);
        }
    },
    addToLoader:function(){
        var res={
            "witch_bad":_IMG_SERV+"/gfx/place/hall2019game/anims/bad/skeleton.json",
            "witch_good":_IMG_SERV+"/gfx/place/hall2019game/anims/good/skeleton.json",
            "thunder":_IMG_SERV+"/gfx/place/hall2019game/effects/thunder/skeleton.json",
            "puff_pink":_IMG_SERV+"/gfx/place/hall2019game/effects/puff_pink/skeleton.json",
            "puff_green":_IMG_SERV+"/gfx/place/hall2019game/effects/puff_green/skeleton.json",
            "workaround":_IMG_SERV+"/gfx/place/hall2019game/woraround.jpg"
            
        },i,bum,girl_id;
        for(girl_id in this.girlSet){
            bum=this.girlSet[girl_id].addToLoader();
            res=$.extend(true,res,bum);
            res["girl_png"+girl_id]=_IMG_SERV+"/gfx/place/hall2019game/guitar/girls_png/"+$.takeGirlImage(girl_id)+".png"
        }
        return res;
    },
    startMove:function(){
        var th=this;
        _moduleTimeHandler.setOne(this.timeIndex.good,function(){
            th.puffArr.pink_in.playAnim("animation");
            th.storage.activeArr[0].alpha=0;
            th.puffArr.pink_in.onCompleteOnce(
                function(){
                    var last_obj=th.prepareMove();
                }
            );
        },500);
        
        this.good.playAnim("animation2");
        
        _mySound.playSound("hall2019_wand");
        
                
    },
    prepareMove:function(){
        var distance=this.conf.lineX[this.conf.lineX.length-1]-this.conf.lineX[this.conf.lineX.length-2];
        var pos_x=this.conf.lineX[this.conf.lineX.length-1]+distance;
        var have_ids=[],random_ids=[];
        var i,i_max,obj,girl_id;
        for(i in this.storage.activeArr){
            obj=this.storage.activeArr[i];
            have_ids.push(obj.takeGirlId());
        }
        for(i in this.girl_ids){
            girl_id=this.girl_ids[i];
            if(!in_array(girl_id,have_ids)){
                random_ids.push(girl_id);
            }
            
        }
        girl_id=getRandomArrayElements(random_ids,1)[0];
       
        this.girlSet[girl_id].x=pos_x;
        this.girlSet[girl_id].fadeIn(15);
        this.storage.activeArr.push(this.girlSet[girl_id]);
        i_max=this.storage.activeArr.length;
        
        for(i=1;i<i_max;i++){
            obj=this.storage.activeArr[i];
            obj.to_move={
                step:0,step_max:80,pos:[obj.x,obj.y],
                dir:[this.conf.lineX[i-1]-obj.x,0]
            };
        }
        var last_obj=this.storage.activeArr.shift();
        var girl_id_last=last_obj.takeGirlId();
        
        this.startChibi(girl_id_last);
        
        return last_obj;
    },
    startChibi:function(girl_id){
        
        var pos_start=[this.girlCointainer.x,this.girlCointainer.y];
        pos_start[0]+=0;
        pos_start[1]-=80;
        var pos_end=[854,312];
        var step_max=400;
        
        var endFun=[];
        var th=this;
        if(mt_rand(1,100)<50 && this.storage.was_started){
            endFun.push({step:mt_rand(40,80)/100*step_max,fun:function(){
                    
                var th_item=this;    
               
                th.bad.playAnim("animation3");
                
                _moduleTimeHandler.setOne(th.timeIndex.bad,function(){
                    var pos=[th_item.x,th_item.y];
                    th_item.addToFade=0;
                    th_item.endNow();
                    var puff=new myPixiObj.drawCustom({
                        pos_start:[pos[0],pos[1]],
                        pos_end:[pos[0],pos[1]],
                        img:"puff_green",
                        step_max:30,
                        anim_type:"spine",
                        spine_conf:{
                            spineResource:th.resources,
                        },

                    });
                    th.animCointainer.addChild(puff);
                    th.animArr.push(puff);

                    var obj=new myPixiObj.drawCustom({
                        pos_start:[pos[0],pos[1]-180],
                        pos_end:[pos[0],pos[1]-180],
                        img:"thunder",
                        scale_arr:[130,130],
                        step_max:30,
                        anim_type:"spine",
                        spine_conf:{
                            spineResource:th.resources,
                        },

                    });
                    th.animCointainer.addChild(obj);
                    th.animArr.push(obj);
                },500);
                
            }});
        }
        
        
        var obj=new myPixiObj.drawCustom({
            pos_start:copyArray(pos_start),
            pos_end:copyArray(pos_end),
            img:"girl_png"+girl_id,
            step_max:step_max,
            scale_arr:[100,50],
            chibiMove:{step_max:10,y_max:10,angle_max:10},
            onStepArr:endFun,//{step:40,fun:function()}
        });
        obj.addToFade=1;
        this.animCointainer.addChild(obj);
        this.animArr.push(obj);
        
    },
    start:function(){
        this.storage.was_started=true;
        this.bad.fadeIn(30);
    },
    myUpdate:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        var girl_id,i,i_max,obj,div;
        for(girl_id in this.girlSet){
            this.girlSet[girl_id].myUpdate(delta);
        }
        for(i in this.storage.activeArr){
            obj=this.storage.activeArr[i];
            if(typeof obj.to_move!="undefined" && obj.to_move.step<obj.to_move.step_max){
                obj.to_move.step+=delta;
                obj.to_move.step=Math.min(obj.to_move.step_max,obj.to_move.step);
                div=obj.to_move.step/obj.to_move.step_max;
                obj.x=obj.to_move.pos[0]+obj.to_move.dir[0]*div;
            }
        }
        
        
        i_max=this.animArr.length-1;
        for(i=i_max;i>=0;i--){
            obj=this.animArr[i];
            if(!obj.update(delta)){
                this.animArr.splice(i,1);
                if(typeof obj.addToFade!="undefind" && obj.addToFade==1){
                    obj.to_del=0;
                    obj.myObj.fadeOut(40,{onEnd:function(){
                            obj.to_del=1;
                    }});
                    this.fadeArr.push(obj);
                }
                else{
                    obj.remove();
                }
                
                
            }
        }
        
        
        this.bad.myUpdate(delta);
        
        i_max=this.fadeArr.length-1;
        for(i=i_max;i>=0;i--){
            obj=this.fadeArr[i];
            obj.myObj.myUpdate(delta);
            if(obj.to_del==1){
                obj.remove();
                this.fadeArr.splice(i,1);
            }
        }
        
        
        
    }
});

